import { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { WEB_FONT_REGULAR_WEIGHT } from 'HubStyleTokens/misc';
import { BATTLESHIP, CALYPSO_LIGHT } from 'HubStyleTokens/colors';
import { DROPDOWN_ITEM_DEFAULT_HEIGHT } from 'HubStyleTokens/sizes';
import { BASE_FONT_COLOR } from 'HubStyleTokens/theme';
import { CALL_FROM_BROWSER, CALL_FROM_PHONE, CALL_FROM_HUBSPOT_APP } from 'calling-internal-common/constants/CallMethods';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
// @ts-expect-error module is not typed
import DropdownMenuOption from 'UIComponents/dropdown/internal/DropdownMenuOption';
import UIList from 'UIComponents/list/UIList';
import UIBadge from 'UIComponents/badge/UIBadge';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MAX_OPTIONS = 4;
const StyledUIList = styled(UIList).withConfig({
  displayName: "CallDeviceOptions__StyledUIList",
  componentId: "sc-17lhcsx-0"
})(["overflow-y:auto;max-height:calc((", " + 0.5) * ", ");border-bottom:", ";"], MAX_OPTIONS, DROPDOWN_ITEM_DEFAULT_HEIGHT, ({
  useborder
}) => useborder && `1px solid ${BATTLESHIP}`);
const StyledDropdownMenuOption = styled(DropdownMenuOption).withConfig({
  displayName: "CallDeviceOptions__StyledDropdownMenuOption",
  componentId: "sc-17lhcsx-1"
})(["cursor:pointer;&&{width:100%;color:", ";font-weight:", ";}&&:hover{color:", ";text-decoration:none;}&:hover{background-color:", ";}"], BASE_FONT_COLOR, WEB_FONT_REGULAR_WEIGHT, BASE_FONT_COLOR, CALYPSO_LIGHT);
function CallDeviceOptions({
  device,
  onSelect,
  disabled,
  isHubSpotProvidedNumber,
  useBorder
}) {
  const callMethodOptions = useMemo(() => {
    const options = [{
      key: CALL_FROM_BROWSER,
      text: 'callHostWidget.settings.callFromBrowser'
    }, {
      key: CALL_FROM_PHONE,
      text: 'callHostWidget.settings.callFromPhone',
      disabled: isHubSpotProvidedNumber,
      disabledTooltipMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "callee-phone-numbers.choosePersonalNumber"
      })
    }, {
      key: CALL_FROM_HUBSPOT_APP,
      text: 'callHostWidget.settings.callFromHubSpotApp',
      badge: /*#__PURE__*/_jsx(UIBadge, {
        use: "new",
        style: {
          marginLeft: '7px'
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "callHostWidget.settings.new"
        })
      })
    }];
    return options;
  }, [isHubSpotProvidedNumber]);
  return /*#__PURE__*/_jsx(StyledUIList, {
    useborder: useBorder ? 1 : 0,
    children: callMethodOptions.map(option => {
      const key = option.key;
      const selectedKeyOption = device;
      const title = option.disabledTooltipMessage;
      let keyString = key;
      const badge = option.badge;
      const shouldDisableTooltip = !option.disabled;
      const selected = key === selectedKeyOption;
      keyString = key;
      const Message = /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: option.text
        }), badge]
      });
      return /*#__PURE__*/_jsx(UITooltip, {
        title: title,
        disabled: shouldDisableTooltip,
        placement: "bottom",
        children: /*#__PURE__*/_jsx(StyledDropdownMenuOption, {
          selected: selected,
          onClick: () => onSelect(key),
          disabled: disabled || option.disabled,
          "data-selenium-test": `pre-call-option-${keyString}`,
          children: Message
        }, keyString)
      }, keyString);
    })
  });
}
CallDeviceOptions.propTypes = {
  device: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isHubSpotProvidedNumber: PropTypes.bool.isRequired
};
export default /*#__PURE__*/memo(CallDeviceOptions);